<template>
  <div class="text-left">
    <div v-if="!readonly">
   Evaluation for <h4 class="green--text"> {{ admissionDetails.application_details.candidate_first_name }} {{ admissionDetails.application_details.candidate_middle_name }} {{ admissionDetails.application_details.candidate_last_name }} ({{ admissionDetails.admission_unique_id }}) </h4> is complete. Would you like to confirm the admission and proceed to setup
      the fees payment details ?
    <v-divider></v-divider>
    </div>
    <div v-else>
      <p class="red--text">You can edit the details in student profile.</p>
    </div>
    <v-form v-model="confirmationForm" :disabled="readonly">
      <div class="my-2">
      <p class="font-weight-medium text-left mb-0">Student Details</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                :items="rooms"
                label="* Classroom"
                class="rounded-input"
                placeholder="eg. 1st A"
                v-model="userDetails.room"
                :rules="[rules.required]"
                item-text="sections"
                item-value="id"
                return-object
                outlined
                dense
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="userDetails.gr_no"
                :rules="[rules.length10, rules.required]"
                outlined
                class="rounded-input"
                label="* GR no."
                dense
                placeholder="eg. A-1411"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-btn
               v-if="readonly" 
               color="primary"
               :to="{name:'StudentDetails',params:{id: userDetails.id}}"
              >
              Student Profile
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div>
        <p class="font-weight-medium text-left mb-0">Fee Details</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="userDetails.room ? getRoomCategories(): []"
                label="Fee Category"
                class="rounded-input"
                placeholder="eg. OBC" 
                v-model="userDetails.fee_category"
                item-text="code"
                item-value="id"
                return-object
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-btn
               v-if="readonly" 
               color="primary"
               :to="{name:'StudentFeeDetails',params:{sid: userDetails.id}}"
              >
              Fee Account
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div>
        <p class="font-weight-medium text-left mb-0">Student App Login Details</p>
        <v-container>
          <v-row>
           <v-col cols="12" sm="6" md="4">
              <v-text-field
                  v-model="userDetails.username"
                  :rules="[rules.required, rules.usernameValidation]"
                  max="20"
                  outlined
                  class="rounded-input"
                  dense
                  :error-messages="usernameError"
                  @change="checkUsernameExists"
                  label="* Username"
                  placeholder="eg. manishp or 9991091091"
                  id="username"
                  type="text"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-btn color="primary" @click="copyPhoneToUsername" v-if="!readonly && admissionDetails.application_details.mobileno && admissionDetails.application_details.mobileno != userDetails.username" >Copy from Phone</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-form>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";

export default {
  name: "ConfirmationStepperContent",

  props:{
    admissionDetails:{
      default: ()=> {
        return {
          id: null,
          application_details: {
            candidate_first_name: null,
            candidate_middle_name: null,
            candidate_last_name: null,
            admission_unique_id: null,
            class_standard:{
              academic_session:{
                id: null,
                title: null,
              }
            }
          },
          student:{
            room:{}
          }
        };
      },
      type: Object
    },
    userDetails: {
      default: ()=> {
        return {
          room : null,
          gr_no : null,
          fee_category : null,
          username: null,
        };
      },
    },
    readonly:{
      default: false,
      type: Boolean
    },
    is_from_portal: {
      default: false,
      type: Boolean,
    },
  },
  data(){
    return {
      rooms: [],
      fee_categories: [],
      confirmationForm: false,
      usernameError: null,
      rules: {
        required: (v) => !!v || "Required",
        fullNameLength: (v) => !v || v?.length<=70 || "Too Long",
        nameLength: (v) => !v || v?.length<=40 || "Max length is 40",
        charsOnly: (v) => !/[^a-zA-Z. ]/.test(v) || "Invalid",
        usernameValidation: (v) => !v || !/[^a-zA-Z0-9.]/.test(v) || "Invalid",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
        phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",
        emailOnly: (v) => !v ||
          /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(
            v
          ) || "Not a valid email",
        length30 : (v) => !v || v?.length<=30 || "Too long",
        length10: (v) => !v || v?.length<=10 || "Max 10 digits",
        email: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        aadhar: (v) => !v || v.length == 12 || "Invalid Aadhar Number",
        percentage: (v) => /(100(\.0{1,2})?$)|^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$/.test(v)|| "Enter valid percentage",
      },
      snackbar: {
        visible: false,
        text: "",
      },
    };
  },
  computed:{
    ...mapGetters(["accessToken", "currentUser", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods:{ 
    ...mapActions(["setLoading"]),

    async getRooms() {
      if(this.admissionDetails.application_details.class_standard.academic_session.id){
        var url = Helper.addUrlParams(endpoints.getRooms,`session=${this.admissionDetails.application_details.class_standard.academic_session.id}`)
        this.rooms = await api.call(this.apiEssentials, url);
      }
    },

    async getAllCategories(){
      if(this.admissionDetails.application_details.class_standard.academic_session.fee_session){
        var url = Helper.addUrlParams(endpoints.getAllCategories, `session=${this.admissionDetails.application_details.class_standard.academic_session.fee_session}`)
        this.fee_categories = await api.call(this.apiEssentials, url);

      }
    },

    containsRoom(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
      return false;
    },

    getRoomCategories(){
      // this.rooms.filter(x => x)
        // let categories = this.fee_categories;
        let selected_room = this.userDetails.room;
        return this.fee_categories.filter((category) =>  this.containsRoom(selected_room, category.rooms))
    },

    copyPhoneToUsername() {
      this.userDetails.username = this.admissionDetails.application_details.mobileno;
      this.checkUsernameExists(this.userDetails.username);
    },

    async checkUsernameExists(username){
      var url = endpoints.checkUsernameExists + `?username=${username}`
      if(await api.call(this.apiEssentials,url)){
        this.usernameError = "Username Exists";
      }
      else{
        this.usernameError = null;
      }
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // Do not TOUCH or change names 
    async saveFormDetails(){
      if(!this.confirmationForm){
        alert("Form Not Valid");
        return;
      }
      var url = endpoints.admissions + `confirmation/${this.admissionDetails.id}/`;
      var post_body = {
        userDetails : this.userDetails,
      }
      var response = await api.call(this.apiEssentials,url,api.Methods.POST, post_body);
      if (response instanceof Error){
        this.setLoading(false); 
        this.snackbar.text = "Error saving details";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: response.id }});
      this.$emit("save-response",{ step: 5 ,name: 'confirmationDetails', value: response});
      this.confirmationForm = false;
      this.snackbar.text="New Student Details Saved. Password is same as phone number.";
      this.snackbar.visible=true;
    },
  },
  watch: {
    // DO NOT TOUCH
    confirmationForm(){
      this.$emit("form-change",{ step: 5 ,name: 'confirmationForm', is_valid: this.confirmationForm});
    },
    admissionDetails(){
      if(this.admissionDetails.application_details.class_standard.academic_session.id){
        this.getRooms();
        this.getAllCategories();
      }
    }
  },
  created(){
    this.getRooms();  
    this.getAllCategories();
  }

};
</script>

<style>
</style>